import styled from 'styled-components';
import { body2Bold, colors, mediumShadow, spacing } from 'ui/theme';
import { body2, caption, link2, overline } from 'ui/theme/typography';

import { pxToRem } from 'utils/convert';
import { Spinner } from 'ui/spinner';
import { WF_Z_INDEX } from '../../constants';

export const AnalyticsContainer = styled.div`
  display: flex;
  flex-direction: column;
  right: ${spacing.base};
  top: ${spacing.eighth};
  position: absolute;
  z-index: ${WF_Z_INDEX.WF_ANALYTICS};
  margin-top: ${spacing.base};
  border-radius: ${spacing.quarter};
  ${mediumShadow};
  background: ${colors.white};
  padding: ${spacing.threeQuarter} ${spacing.base} 0 ${spacing.base};
`;

export const PanelWrapper = styled.div`
  display: flex;
  flex-direction: column;
  background: ${colors.white};
  width: ${pxToRem(304)};
  border-radius: ${spacing.quarter};
  ${mediumShadow};
  gap: ${spacing.base};
`;

export const PrimaryPanel = styled.div`
  ${body2};
`;

export const SelectedTilePanel = styled.div`
  background: ${colors.backgroundSecondary};
  /* shadows/insetShadow */
  box-shadow: 0px 3px 8px 0px rgba(0, 0, 0, 0.06) inset;

  display: flex;
  padding: ${spacing.base};
  flex-direction: column;
  align-items: flex-start;
  gap: ${spacing.half};
  align-self: stretch;
`;

export const UpperPanel = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  width: 100%;
  gap: ${spacing.half};
`;

export const CollapsibleButton = styled.div`
  display: flex;
  cursor: pointer;
`;

export const CollapsibleContentWrapper = styled.div`
  padding-top: ${spacing.half};
`;

export const CountPanel = styled.div`
  width: 100%;
  padding: 0;
`;

export const VisitorCountText = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: ${spacing.quarter};
  &:last-child {
    margin-bottom: 0;
  }
`;

export const InProgressValue = styled.div<{ href?: string; as?: string }>`
  display: flex;
  align-items: center;
  /** If a link is used, use link styling */
  ${(props) => (props.href && props.as === 'a' ? link2 : ``)}
`;

export const CountText = styled.div`

`;

export const CountValue = styled.div`
  ${({ hasOnClick }: { hasOnClick?: boolean }) =>
    hasOnClick
      ? link2
      : `
    align-self: flex-start;
  `}
`;

export const WorkflowStatus = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  &:last-child {
    margin-bottom: 0;
  }
  > * + * {
    margin-left: ${spacing.half};
  }
`;

export const IconContainer = styled.div`
  align-items: center;
  display: flex;
  flex-shrink: 0;
  margin-right: ${spacing.eighth};
`;

export const StyledTitleText = styled.span`
  ${body2Bold};
`;

export const StyledSelectedTileTitleText = styled.span`
  ${overline}
  color: ${colors.textSecondary};
`;

export const FooterWrapper = styled.div`
  margin-top: ${spacing.threeQuarter};
`;

export const SelectedTileHeader = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing.half};
  align-self: stretch;
`;

export const ConversionDateText = styled.div`
  margin: ${spacing.half} 0 0  0;
  ${caption}
  color: ${colors.textDisabled};
`;

export const StyledSpinner = styled(Spinner)`
  width: 100%;
  align-self: center;
`;

export const SelectedNodeContainer = styled.div`
  margin: 0 -${spacing.base};
`;

export const SelectedConversionContainer = styled.div`
  margin: 0 -${spacing.base} 0 -${spacing.base};
  border-bottom-left-radius: ${spacing.quarter};
  border-bottom-right-radius: ${spacing.quarter};
`;

export const ContactsContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

/* Journey Panel */

export const JourneyPanelTitle = styled.div`
  display: flex;
  gap: ${spacing.half};
  flex-direction: column;
  justify-content: flex-start;
  width: 100%;
   margin-bottom: ${spacing.fiveEights};
`;

export const JourneyPanelBody = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
`;

export const InsightsButtonContainer = styled.div`
  display: flex;
  height: 35px;
`;

export const CardDateTime = styled.div`
  ${colors.textSecondary};
  ${caption}
`;
